<template>
  <div class="quote-wrapper">
    <div class="quote-div">
      <new-quote></new-quote>
    </div>
  </div>
</template>

<script>
import NewQuote from '@/components/NewQuote.vue';

export default {
  components: {
    NewQuote,
  },
};
</script>

<style>
.quote-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
}
.quote-div {
  width: 900px;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 920px) {
  .quote-div {
    width: 95%;
  }
}
</style>
